import React from 'react';

import { Text } from '@mantine/core';

import styles from './cellsV2.module.scss';

interface ClinicCellProps {
  clinicName: string;
}

export const ClinicCell: React.FC<ClinicCellProps> = ({ clinicName }) => (
  <Text className={styles.cell} fz={14}>{clinicName || '—'}</Text>
);
